import Vue from 'vue';
import {
  ConfigProvider,
  Carousel,
  Input,
  InputNumber,
  Button,
  AutoComplete,
  Anchor,
  // Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Icon,
  Badge,
  // Popover,
  Dropdown,
  List,
  Avatar,
  // Breadcrumb,
  Steps,
  Spin,
  Menu,
  // Drawer,
  // Tooltip,
  Alert,
  // Tag,
  Divider,
  DatePicker,
  // TimePicker,
  Upload,
  // Progress,
  // Skeleton,
  // Popconfirm,
  message,
  notification,
  // pagination,
  // cascader,
  descriptions,
  Result,
  // comment,
  // calendar,
  // affix,
  // empty,
  statistic,
  // BackTop,
} from 'ant-design-vue';
// import { BackTop } from 'node_modules/ant-design-vue/types/index'
// import VueCropper from 'vue-cropper'

Vue.use(ConfigProvider);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Button);
Vue.use(Anchor);
// Vue.use(Switch);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Card);
Vue.use(Form);
Vue.use(Row);
Vue.use(Col);
Vue.use(Modal);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Badge);
// Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(List);
Vue.use(Avatar);
// Vue.ue(Breadcrumb);
Vue.use(Steps);
Vue.use(Spin);
Vue.use(Menu);
// Vue.use(Drawer);
// Vue.use(Tooltip);
Vue.use(Alert);
// Vue.use(Tag);
Vue.use(Divider);
Vue.use(DatePicker);
// Vue.use(TimePicker);
Vue.use(Upload);
// Vue.use(Progress);
// Vue.use(Skeleton);
// Vue.use(Popconfirm);
// // Vue.use(VueCropper)
Vue.use(notification);
// Vue.use(pagination);
// Vue.use(cascader);
Vue.use(descriptions);
Vue.use(Result);
Vue.use(AutoComplete);
// Vue.use(comment);
// Vue.use(affix);
// Vue.use(calendar);
// Vue.use(empty);
Vue.use(statistic);
// Vue.use(BackTop);

Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
